module.exports = __webpack_public_path__ + "static/img/lucre-games-geotap-game-casual-relaxing-low=poly-design-game-cards.315cc89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/geotap-game/lucre-games-geotap-game-casual-relaxing-low=poly-design-game-cards.png
// module id = C2r1
// module chunks = 0